import { render, staticRenderFns } from "./CloudServices.vue?vue&type=template&id=dfffcc14&scoped=true&"
import script from "./CloudServices.vue?vue&type=script&lang=js&"
export * from "./CloudServices.vue?vue&type=script&lang=js&"
import style0 from "./CloudServices.vue?vue&type=style&index=0&id=dfffcc14&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfffcc14",
  null
  
)

export default component.exports